export default __webpack_public_path__ + "static/media/Supabase-dark.405d6d1a.png";